import { Link, useParams } from 'react-router-dom'
import { BlogDetailSkeleton } from '../components/Skeleton'
import { formatDate } from '../helpers/format'
import { useBlogPost } from '../hooks/useBlogPost'
import '../styles/blog-page.scss'

export function BlogPostPage() {
  const { slug } = useParams<{ slug: string }>()
  const { post, loading, error } = useBlogPost(slug)

  if (loading) {
    return <BlogDetailSkeleton />
  }

  if (error || !post) {
    return (
      <div className="blog-page">
        <div className="container">
          <p className="catalog-status catalog-status--error">{error ?? 'Article not found'}</p>
          <Link to="/blog" className="blog-back-link">
            ← Back to blog
          </Link>
        </div>
      </div>
    )
  }

  return (
    <article className="blog-page blog-page--detail">
      <header className="blog-detail__hero">
        <div className="container blog-detail__hero-inner">
          <Link to="/blog" className="blog-back-link">
            ← Back to blog
          </Link>
          {post.publishedAt ? (
            <time className="blog-detail__date" dateTime={post.publishedAt}>
              {formatDate(post.publishedAt)}
            </time>
          ) : null}
          <h1>{post.title}</h1>
          <p className="blog-detail__byline">By {post.authorName}</p>
          {post.tags.length > 0 ? (
            <ul className="blog-detail__tags">
              {post.tags.map((tag) => (
                <li key={tag}>{tag}</li>
              ))}
            </ul>
          ) : null}
        </div>
        {post.coverImageUrl ? (
          <div className="container blog-detail__cover">
            <img src={post.coverImageUrl} alt="" />
          </div>
        ) : null}
      </header>

      <div className="container blog-detail__content">
        {post.excerpt ? <p className="blog-detail__excerpt">{post.excerpt}</p> : null}
        <div
          className="blog-detail__body"
          dangerouslySetInnerHTML={{ __html: post.body }}
        />
      </div>
    </article>
  )
}
